import { Link } from "react-router-dom";
import { buildWhatsappLink, dressInquiryMessage } from "@/lib/whatsapp";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const fullUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export default function DressCard({ dress, whatsappNumber, index = 0 }) {
  const waLink = buildWhatsappLink(whatsappNumber, dressInquiryMessage(dress));
  const fmt = (n) => `${Number(n).toFixed(0)} €`;
  const mainImage = fullUrl((dress.images && dress.images[0]) || dress.image_url);
  const extraCount = Array.isArray(dress.images) ? Math.max(0, dress.images.length - 1) : 0;

  return (
    <article
      data-testid={`dress-card-${dress.number}`}
      className="group flex flex-col gap-4"
      style={{ animation: `fade-up 0.8s ease-out ${index * 60}ms both` }}
    >
      <Link to={`/kleid/${dress.id}`} className="block relative overflow-hidden bg-stone-50 aspect-[3/4]">
        {mainImage ? (
          <img
            src={mainImage}
            alt={dress.name}
            className="absolute inset-0 w-full h-full object-contain transition-transform duration-[800ms] ease-out group-hover:scale-[1.02]"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-ink/30 font-display text-2xl">
            Kleid {dress.number}
          </div>
        )}
        <div className="absolute top-4 left-4 bg-cream/95 backdrop-blur px-3 py-1.5">
          <span className="overline">Nr. {dress.number}</span>
        </div>
        <div className="absolute top-4 right-4 bg-ink text-cream px-3 py-1.5 text-[10px] uppercase tracking-widest">
          Unikat
        </div>
        {extraCount > 0 && (
          <div className="absolute bottom-4 right-4 bg-cream/95 backdrop-blur px-2.5 py-1 text-[10px] uppercase tracking-widest text-ink">
            +{extraCount} {extraCount === 1 ? "Bild" : "Bilder"}
          </div>
        )}
        {!dress.available && (
          <div className="absolute inset-0 bg-cream/70 flex items-center justify-center">
            <span className="overline text-ink">Aktuell vergeben</span>
          </div>
        )}
      </Link>

      <div className="flex flex-col gap-1">
        <h3 className="font-display text-2xl leading-tight">{dress.name}</h3>
        <div className="text-sm text-ink/60 flex items-center gap-3">
          <span>Größe {dress.size}</span>
          <span className="w-1 h-1 bg-ink/30 rounded-full" />
          <span>{dress.color}</span>
        </div>

        {/* Price block — both options */}
        <div className="mt-3 grid grid-cols-2 gap-2 border-y border-[#E5E0D8] py-3">
          <div>
            <div className="overline text-[10px]">Miete</div>
            <div className="font-display text-xl text-gold leading-tight">{fmt(dress.price)}</div>
            <div className="text-[11px] text-ink/55">+ Kaution {fmt(dress.deposit)}</div>
          </div>
          {dress.sale_price ? (
            <div className="border-l border-[#E5E0D8] pl-3">
              <div className="overline text-[10px]">Kauf</div>
              <div className="font-display text-xl text-ink leading-tight">{fmt(dress.sale_price)}</div>
              <div className="text-[11px] text-ink/55">Unikat behalten</div>
            </div>
          ) : (
            <div className="border-l border-[#E5E0D8] pl-3 flex items-center text-[11px] text-ink/40 uppercase tracking-widest">
              Nur Miete
            </div>
          )}
        </div>

        {dress.description && (
          <p className="text-sm text-ink/70 mt-2 line-clamp-2">{dress.description}</p>
        )}

        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <a
            data-testid={`whatsapp-card-${dress.number}`}
            href={waLink}
            target="_blank"
            rel="noreferrer"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 text-xs tracking-widest uppercase hover:bg-[#1EBE57] transition-colors duration-300"
          >
            WhatsApp Anfrage
          </a>
          <Link
            data-testid={`details-card-${dress.number}`}
            to={`/kleid/${dress.id}`}
            className="flex-1 inline-flex items-center justify-center bg-ink text-cream py-3 text-xs tracking-widest uppercase hover:bg-gold transition-colors duration-300"
          >
            Details
          </Link>
        </div>
      </div>
    </article>
  );
}
